import { reactive } from 'vue';

/**
 * Estado global de la interfaz (barra lateral abrir/cerrar).
 * Fuente única de verdad para el toggle desde el Header y el Sidebar.
 */
const abiertaPorDefecto =
  typeof window !== 'undefined' ? window.innerWidth >= 992 : true;

export const ui = reactive({
  sidebarOpen: abiertaPorDefecto,
});

export function toggleSidebar() {
  ui.sidebarOpen = !ui.sidebarOpen;
}

export function openSidebar() {
  ui.sidebarOpen = true;
}

export function closeSidebar() {
  ui.sidebarOpen = false;
}
